import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { h4, graphTitle } from '@/styles/typography'
import { Link } from 'gatsby'

const normal = css`
  color: black;
  background-color: white;
`

const inverted = css`
  color: white;
  background-color: black;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  ${props => (props.odd ? inverted : normal)}
  align-items: center;
  z-index: 10000;
  position: relative;
  z-index: 2;
  will-change: color, background-color;
  transition: all 0.2s;
  > * {
    transition: all 0.2s;
  }
  &:hover {
    ${props => (props.odd ? normal : inverted)}
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.4rem;
    > div {
      &:first-of-type {
        order: 2;
      }
    }
  }
`

const Content = styled.div`
  padding: 2rem 4rem;
  @media (max-width: 768px) {
    padding: 2rem;
  }
  h2 {
    ${h4};
    margin-bottom: 2rem;
  }
  .excerpt {
    p {
      ${graphTitle};
    }
  }
`

const ArticleCard = ({
  title,
  type = 'article',
  excerpt,
  slug,
  featuredImage,
  odd,
}) => {
  const image = featuredImage?.node?.localFile

  return (
    <Link to={`/${slug}/`}>
      <Container odd={odd}>
        <Content>
          <h2>{title}</h2>
          <div
            className="excerpt"
            dangerouslySetInnerHTML={{ __html: excerpt }}></div>
          <span className="inline-block px-4 py-2 border-2 mt-4">ver más</span>
        </Content>
        <div>
          {image && (
            <figure>
              <GatsbyImage image={getImage(image)} alt="" />
            </figure>
          )}
        </div>
      </Container>
    </Link>
  )
}

export default ArticleCard
